<template>
  <div>
    <v-row
        align="center"
        justify="center"
    >
      <v-col
          class="file-area"
          @dragover.prevent
          @drop.prevent="dropFile"
          cols="11"
      >
        <v-row
            align="center"
            justify="center"
        >
          <v-col cols="8">
            <input
                v-if="isFileSelect"
                type="file"
                style="display:none"
                @change="changeFile"
                :accept="accept"
                ref="fileInput"
            >
            このエリアにドロップしてください(複数ファイル送信不可)
          </v-col>
          <v-col cols="2">
            <div class="file-area-btn">
              <v-btn
                  rounded
                  color="white blue--text"
                  border="1px"
                  @click.stop="clickChooseBtn"
              >
                ファイル選択
                <v-icon
                    right
                    dark
                >
                  mdi-file-document-outline
                </v-icon>
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row
        align="center"
        justify="center"
    >
      <v-col cols="8">
        <v-text-field
            v-model="fileName"
            readonly
        ></v-text-field>
      </v-col>
      <v-col cols="3">
        <v-btn
            rounded
            class="common-save-btn"
            @click.stop="csvUpload"
            v-bind:disabled="this.isUploadBtnDisabled"
        >
          CSVアップロード
          <v-icon
              right
              dark
          >
            mdi-upload
          </v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row
        align="center"
        justify="center"
        v-if="this.error !== ''"
    >
      <v-col
          cols="11"
      >
        <v-alert
            class="ma-3"
            dense
            type="error"
        >
          {{ this.error }}
        </v-alert>
      </v-col>
    </v-row>
  </div>
</template>

<style lang="scss">
.file-area {
  position: relative;
  background-color: #F0F2F8;
  border-radius: 10px;

  .file-area-btn {
    text-align: center;
  }
}
</style>


<script>
import axios from "axios";
import {UNPROCESSABLE_ENTITY} from "../../../../util";

export default {
  data() {
    return {
      fileName: "",
      csvFile: null,
      isUploadBtnDisabled: true,
      error: ''
    }
  },
  props: {
    isFileSelect: {
      type: Boolean,
      default: false,
    },
    accept: {
      type: String,
      default: ""
    },
    fileInputName: {
      type: String,
      default: "file",
    },
  },

  mounted() {
    if (this.isFileSelect)
      this.fileName = "";
    this.isUploadBtnDisabled = true;
  },
  methods: {
    clickChooseBtn(event) {
      if (this.isFileSelect) {
        this.$refs.fileInput.click()
      } else {
        this.$emit('click', event);
      }
    },
    async csvUpload() {
      const url = "/user/csvUpload";
      let formData = new FormData();
      formData.append("user_list_file", this.csvFile);

      const response = await axios.post(
          url,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          }
      )
      // API実行後、formを初期化する
      this.initFileElement()
      const result = response.data?.result;
      const status = response.status;
      if (status === UNPROCESSABLE_ENTITY) {
        this.error = response.data.errors[0];
      } else if (result) {
        this.$emit("fileUploadClose");
      }

    },
    dropFile(event) {
      if (this.isFileSelect) {
        this.emitFileChange(event.dataTransfer.files)
      }
    },
    changeFile(event) {
      this.emitFileChange(event.target.files)
    },
    emitFileChange(files) {
      if (files.length !== 0) {
        this.csvFile = files[0];
        this.fileName = files[0]['name'];
        this.isUploadBtnDisabled = false;
      } else {
        this.fileName = "";
      }

      this.$emit('change', files);
    },
    initFileElement() {
      this.$refs.fileInput.value = null
      this.csvFile = null;
      this.fileName = "";
      this.isUploadBtnDisabled = true;
      this.error = "";
    }
  }
}

</script>
